const suppliers = {
  toast: {
    error: {
      badResponse: '[Fleet] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fleet] se ha creado correctamente',
      },
      edit: {},
    },
  },
  create: {
    successToast: {
      message: '¡Éxito! ¡Fleet creado!',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear la flota',
    },
  },

  edit: {
    successToast: {
      message: '¡Éxito! ¡Fleet actualizado!',
    },
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar la flota',
    },
  },

  deleteModal: {
    header: 'Eliminar flotas',
    body: 'Está a punto de eliminar {{num}} flotas.',
  },

  deleteToast: 'No se pueden eliminar las flotas',

  forms: {
    information: {
      rank: {
        header: 'Clasificación y puntuación de la flota',
      },
      supplierKpis: {
        header: 'KPIs de la flota',
      },
    },
  },
  delete: {
    confirmation: {
      header: 'Confirmación de eliminación de la flota',
      body: 'Las flotas fueron eliminadas correctamente',
    },
  },
};

export default suppliers;
